<template>
  <v-app>

    <v-dialog
        v-model="dialog_detail"
        scrollable
        max-width="800"
      >
          <v-card>
            <v-card-text align="left" class="pt-3" style="color:black">
              <div><b>รายละเอียดนัดหมาย</b></div>
              <div>จุดบริการ : {{ detail.station_name }}</div>
              <div>กลุ่มงานบริการ : {{ detail.group_name }}</div>
              <div>วัน : {{ detail.reservation_date }}</div>
              <div>ช่วงเวลา : {{ detail.reservation_timestart + ' - ' +  detail.reservation_timeend}}</div>
              <div>สถานะ : {{ detail.reservation_status_id == 1 ? "รอยืนยันนัด" : detail.reservation_status_id == 2 ? "รอรับบริการตามนัด" : "" }}</div>
            </v-card-text>
            <v-divider v-if="detail.group_extranote && detail.group_extranote.length > 0"></v-divider>
            <v-card-subtitle align="left" v-if="detail.group_extranote && detail.group_extranote.length > 0">
              <div>หมายเหตุ : </div>
              <div>{{ detail.group_extranote }}</div>
            </v-card-subtitle>

          </v-card>
      </v-dialog>

    <v-dialog
        v-model="dialog_action_confirm"
        persistent
        scrollable
        max-width="600"
      >
          <v-card>
              <v-card-title>
                  ต้องการยกเลิกนัดหมายที่เลือก
              </v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialog_action_confirm=false"
                >
                  ยกเลิก
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="dialog_action_confirm=false;actionCancel();"
                >
                  ยืนยัน
                </v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>

    <div>
      <div class="text-h6 mt-6">
          <v-icon large>mdi-calendar</v-icon>นัดหมายของฉัน
      </div>
      <v-list 
      class="mt-8">
        <v-list-item
          class="ma-3"
          align="left"
          v-for="(item) in appointmentlist"
          :key="item.reservation_id"
          style="border: 4px solid #D7FF66;"
        >
          <v-list-item-content v-on:click="showdetail(item)">
            <v-row>
              <v-col cols="6">
                <v-list-item-title>{{ item.group_name }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.reservation_date }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  {{ item.reservation_timestart + ' - ' +  item.reservation_timeend}}
                </v-list-item-subtitle>
              </v-col>
              <v-col cols="6" class="text-h7">
                <div align="right" class="mt-n5">
                  <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" tile icon @click="select_extradate_close=true">
                            <v-icon>mdi-dots-horizontal</v-icon>
                          </v-btn></template>
                      <v-list>
                          <v-list-item @click="dialog_action_confirm=true;selected_reservation=item;">
                            ยกเลิกนัดหมาย
                          </v-list-item>
                      </v-list>
                  </v-menu>
                </div>
                <div>{{ item.reservation_status_id == 1 ? "รอยืนยันนัด" : item.reservation_status_id == 2 ? "รอรับบริการตามนัด" : "" }}</div>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </v-app>
</template>


<script>

import axios from 'axios';
import config from '@/../config.js'
import Member from '@/models/instance/Member'

export default {
  data () {
    return {
      appointmentlist : [],
      dialog_action_confirm: false,
      selected_reservation : {},
      dialog_detail : false,
      detail : {}
    }
  },
  mounted : function () {
    this.reload()
  },
  methods: {
    showdetail(item){
      
      var que = this.$store.commit('addLoading')
      item['group_extranote'] = ""
      axios
      .post(config.api.url.public.appointment.get_groupshortdetail,{group_id:item.group_id,lang:'th'})
      .then(response => {
        if(response.data.group_extranote){
          item['group_extranote'] = response.data.group_extranote
        }
        this.detail = item
        this.dialog_detail=true
        this.$store.commit('finishLoading',que)
      })
    },
    actionCancel(){
      var que = this.$store.commit('addLoading')
      axios
      .post(config.api.url.line.appointment.manage.edit_status
        ,{reservation_id:this.selected_reservation.reservation_id,to_status:7}
        ,{ headers: Member.getTokenHeader()}
      )
      .then(() => {
        this.$store.commit('finishLoading',que)
        this.reload()
      })
    },
    reload(){
      var que = this.$store.commit('addLoading')
      axios
      .post(config.api.url.line.appointment.manage.get_appointmentlist
        ,{station_code:this.$route.params.station_code,status_id_list:[1,2]}
        ,{ headers: Member.getTokenHeader()}
      )
      .then(response => {
        this.appointmentlist = response.data
        this.$store.commit('finishLoading',que)
        this.appointmentlist.forEach((r,i,arr)=>{
          r.reservation_timestart = '0000' + r.reservation_timestart;
          r.reservation_timestart = r.reservation_timestart.substring(r.reservation_timestart.length-4,r.reservation_timestart.length);
          arr[i]['reservation_timestart']  = r.reservation_timestart.substring(0,2) + ":" + r.reservation_timestart.substring(2,4);
          r.reservation_timeend = '0000' + r.reservation_timeend;
          r.reservation_timeend = r.reservation_timeend.substring(r.reservation_timeend.length-4,r.reservation_timeend.length);
          arr[i]['reservation_timeend']  =  r.reservation_timeend.substring(0,2) + ":" + r.reservation_timeend.substring(2,4);
        })
      })
    }
  }
}
</script>